import React from "react";
import "./styles.scss";
import PropTypes from "prop-types";
import useWindowDimensions from "../../../../hook/useWindowDimension";

const MessagerieWrapper = ({children, showSideBar}) => {
    const width = useWindowDimensions();
    return (
        <div id={showSideBar ? "disabledMessagerie" : "messagerie"}>
            {children}
        </div>
    );
};

MessagerieWrapper.propTypes = {
    children: PropTypes.node,
    showSideBar: PropTypes.bool,
};

export default MessagerieWrapper;